if (!customElements.get('gift-wrap-toggle')) {
  customElements.define(
    'gift-wrap-toggle',
    class GiftWrapToggle extends HTMLElement {
      connectedCallback() {
        this.input = this.querySelector('input');
        this.input.addEventListener('change', this.onChange.bind(this));
      }

      async onChange() {
        this.input.disabled = true;
        const cartDrawer = this.closest('cart-drawer');
        const variantId = this.dataset.variantId;
        const sections = ['cart-drawer', 'cart-icon-bubble'];
        const url = this.input.checked ? `${window.routes.cart_add_url}.js` : `${window.routes.cart_change_url}.js`;
        const body = this.input.checked
          ? { items: [{ id: Number(variantId), quantity: 1 }], sections, sections_url: window.location.pathname }
          : { id: String(variantId), quantity: 0, sections, sections_url: window.location.pathname };

        try {
          const response = await fetch(url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify(body),
          });
          const state = await response.json();
          if (state.status) throw new Error(state.description);

          if (cartDrawer && state.sections) {
            cartDrawer.renderContents(state);
          } else {
            window.location.reload();
          }
        } catch (error) {
          console.error(error);
          this.input.checked = !this.input.checked;
          this.input.disabled = false;
        }
      }
    }
  );
}
